/*global diy, jimdoData*/

var MaintenanceModeModel = require('diy/maintenanceMode/MaintenanceModeModel');

module.exports = new MaintenanceModeModel(jimdoData.webViewDisabled, jimdoData.neverPublished);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/maintenanceMode/maintenanceMode.js
 ** module id = 668
 ** module chunks = 0
 **/